module.exports = __webpack_public_path__ + "d41d8cd98f00b204e9800998ecf8427e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/public/fonts/Montserrat/Montserrat-LightItalic.woff
// module id = 1799
// module chunks = 1